import React from 'react'
import { Link } from 'gatsby'
import Grid from '@material-ui/core/Grid'

import CompanyInfoSection from './components/CompanyInfoSection'
import SocialMediaSection from './components/SocialMediaSection'
import './Footer.scss'

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="footer__top">
          <div className="container">
            <Grid container spacing={2}>
              <Grid item xs={12} lg={7} className="footer__info-wrap">
                <div className="footer__info">
                  <CompanyInfoSection />
                  <nav className="footer__nav">
                    <ul className="footer__menu">
                      <li key={1} className="nav-item">
                        <a href="/how-it-works">How It Works</a>
                      </li>
                      <li key={2} className="nav-item">
                        <a
                          href="https://dailybreaksupport.groovehq.com/help"
                          target="_blank"
                        >
                          Support
                        </a>
                      </li>
                      <li key={3} className="nav-item">
                        <a
                          href="https://www.breaktimemedia.com/"
                          target="_blank"
                        >
                          Advertise
                        </a>
                      </li>
                      <li key={4} className="nav-item">
                        <a
                          href="https://www.breaktimemedia.com/careers"
                          target="_blank"
                        >
                          Careers
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </Grid>
              <Grid item xs={12} lg={5} className="footer__social-wrap">
                <SocialMediaSection />
              </Grid>
            </Grid>
          </div>
        </div>

        <div className="footer__bottom">
          <div className="container">
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} className="footer__copyright-wrap">
                <div className="footer__copyright">
                  <p>
                    &copy; {new Date().getFullYear()} Breaktime Media MWH LLC.
                    All rights reserved.
                  </p>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} className="footer__policy-wrap">
                <div className="footer__policy">
                  <ul>
                    <li>
                      <Link to="/privacy">Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to="/terms">Terms &amp; Conditions</Link>
                    </li>
                  </ul>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer
